import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Draggable } from 'react-beautiful-dnd';
import styles from './ListItem.styles';
const useStyles = makeStyles(styles);

const ListItem = ({ item, index, idField, component }) => (
  <Draggable key={item[idField]} draggableId={item[idField]} index={index}>
    {provided => (
      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
        {component ? (
          React.createElement(component, {
            key: item[idField],
            index,
            item,
          })
        ) : (
          <div>{item[idField]}</div>
        )}
      </div>
    )}
  </Draggable>
);

ListItem.defaultProps = {};
ListItem.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  onDragEnd: PropTypes.func,
  idField: PropTypes.string,
  component: PropTypes.any,
};

export default ListItem;
